import { createApp, h } from 'vue'
import { createI18n } from 'vue-i18n';

import { library, dom } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from "@fortawesome/free-solid-svg-icons"

import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';

import messages from './lang';
import axios from 'axios'
import VueAxios from 'vue-axios'
import { useCookies } from 'vue3-cookies'
import EnvProvider from 'jvjr-docker-env';

library.add(fas);
dom.watch();
const { cookies } = useCookies();
const i18n = createI18n({
    locale: "sk",
    availableLocales: ["sk","cz","en","de","hu"],
    messages,
    globalInjection: true
})

// No cache in response from axios
axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
};

if (EnvProvider.value('ENV') === 'DEV'){
  // FOR DEVELOPMENT ONLY
  axios.defaults.withCredentials = true
};

// Add CSRF token in header if logged in
axios.interceptors.request.use( function (config) {
    let csrf = cookies.get('csrfToken')
	let user = cookies.get('userName')
    if(EnvProvider.value('LOCAL') === 'true' && EnvProvider.value('ENV') === 'DEV'){
      config.headers['x-csrf-token'] = 'dev_bypass';
      csrf = 'dev_bypass'
    }

    if(user != ''){
      config.headers['x-csrf-token'] = csrf;
    }
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error);
  }
);

/* eslint vue/no-dupe-keys: off */
/* eslint no-dupe-keys: off */
import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp({
    el: '#app',
    store: store,
    data () {
        return {
            ENDPOINT_AUTH: '/auth',
            ENDPOINT_SEARCH: '/search',
            ENDPOINT_EXPORT: '/export',
            ENDPOINT_SUGGEST: '/suggest',
            ENDPOINT_HIGHLIGHT: '/highlightedDetail',

            URL_AUTH: EnvProvider.value('URL_AUTH'),
            URL_BACKEND: EnvProvider.value('URL_BACKEND'),
            URL_ANONYMA: EnvProvider.value('URL_ANONYMA'),
            URL_SIGNER: EnvProvider.value('URL_SIGNER'),

            HOST_DOMAIN: EnvProvider.value('HOST_DOMAIN'),
            COOKIE_DURATION: EnvProvider.value('COOKIE_DURATION'),
            DEV_ENV: EnvProvider.value('ENV') === 'DEV',
            LOCAL_ENV: EnvProvider.value('LOCAL') === 'true',
            SIGNER_ENABLED: EnvProvider.value('SIGNER_ENABLED') === 'true',
            
            helpModalShow: false,
            exportModalShow: false,
            profileModalShow: false,

            showContextSearch: true,
            recordsPerPage: 10,
            recordsPerExport: 5,
            
            aggFieldForTab: 'objectTypeId',
            allResultTagId: 'All',
            
            metadataConfigManager: {},
            metadataObjects: [],
            monthsLabels: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december'],
            metadataFields: {},
            metadataGDPRFields: {
                primaryInformations: {
                    label: 'form.basicInfo',
                    id: 'primaryInformations',
                    showItems: false,
                    items: {
                        personName: { id: 'personName', label: "form.basicInfo_.personName", criteriumLabel: 'Meno osoby', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.personName', isFiltered: false },
                        birthNumber: { id: 'birthNumber', label: "form.basicInfo_.identificationNumber", criteriumLabel: 'Rodné číslo', datatype: 'string', isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.birthNumber', isFiltered: false, essential: true },
                        birthDate: { id: 'birthDate', label: "form.basicInfo_.dateOfBirth", criteriumLabel: 'Dátum narodenia', valueFormatter: this.datetimeFormatter, datatype: 'datetime', multivalued: false, isPersonalInformation: true, facet: { facetRangeGap: '/MONTH%2B1MONTH', facetRangeStart: 'NOW-20YEAR', facetRangeEnd: 'NOW', valueFormatter: this.yearMonthFormmater }, slider: { valueForSlider: [], dataForSlider: [], sliderVisibility: false }, helpPhrase: 'helpPhrase.birthDate', isFiltered: false },
                        birthPlace: { id: 'birthPlace', label: "form.basicInfo_.birthplace", criteriumLabel: 'Miesto narodenia', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.birthPlace', isFiltered: false },
                        maritalStatus: { id: 'maritalStatus', label: "form.basicInfo_.familyStatus", criteriumLabel: 'Rodinný stav', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.maritalStatus', isFiltered: false },
                    }
                },
                identification: {
                    label: "form.identification.idDetails",
                    id: 'identification',
                    showItems: false,
                    items: {
                        idCardNumber: { id: 'idCardNumber', label: "form.identification.idNumber", criteriumLabel: 'Číslo OP', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.idCardNumber', isFiltered: false, essential: true },
                        passportNumber: { id: 'passportNumber', label: "form.identification.passportNumber", criteriumLabel: 'Číslo pasu', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.passportNumber', isFiltered: false, essential: true },
                        healthInsurance: { id: 'healthInsurance', label: "form.identification.insuranceCompany", criteriumLabel: 'Zdravotná poisťovňa', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.healthInsurance', isFiltered: false }
                    }
                },
                bank: {
                    label: "form.bank.bankDetails",
                    id: 'bank',
                    showItems: false,
                    items: {
                        iban: { id: 'iban', label: "form.bank.iban", datatype: 'string', bendLabel: 'IBAN', criteriumLabel: 'IBAN', tagLabel: 'IBAN', multivalued: true, isPersonalInformation: true, searchPhrase: [], helpPhrase: 'helpPhrase.iban', isFiltered: false, essential: true },
                        cardNumber: { id: 'cardNumber', label: "form.bank.paymentCardNumber", criteriumLabel: 'Číslo platobnej karty', tagLabel: 'číslo platobnej karty', datatype: 'string', multivalued: true, isPersonalInformation: true, searchPhrase: [], helpPhrase: 'helpPhrase.cardNumber', isFiltered: false, essential: true }
                    }
                },
                contact: {
                    label: "form.contact.contactInformation",
                    id: 'contact',
                    showItems: false,
                    items: {
                        phoneNumber: { id: 'phoneNumber', label: "form.contact.phoneNumber", criteriumLabel: 'Telefónne číslo', tagLabel: 'telefónne číslo', datatype: 'string', multivalued: true, isPersonalInformation: true, searchPhrase: [], helpPhrase: 'helpPhrase.phonenumber', isFiltered: false, essential: true },
                        email: { id: 'email', label: 'form.contact.email', criteriumLabel: 'Email', tagLabel: 'email', datatype: 'string', multivalued: true, isPersonalInformation: true, searchPhrase: [], helpPhrase: 'helpPhrase.email', isFiltered: false, essential: true }
                    }
                },
                residence: {
                    label: "form.residence.residence",
                    id: 'residence',
                    showItems: false,
                    items: {
                        permanentResidenceMunicipality: { id: 'permanentResidenceMunicipality', label: "form.residence.municipality", criteriumLabel: 'Mesto', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.permanentResidenceMunicipality', isFiltered: false },
                        permanentResidenceStreet: { id: 'permanentResidenceStreet', label: "form.residence.street", criteriumLabel: "Ulica", datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.permanentResidenceStreet', isFiltered: false },
                        permanentResidenceZipCode: { id: 'permanentResidenceZipCode', label: "form.residence.zipCode", criteriumLabel: 'PSČ', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.permanentResidenceZipCode', isFiltered: false }
                    }
                },
                job: {
                    label: "form.job.job",
                    id: 'job',
                    showItems: false,
                    items: {
                        companyId: { id: 'companyId', label: "form.job.companyID", criteriumLabel: 'ID zamestnanca', tagLabel: 'ID zamestnanca', datatype: 'number', multivalued: true, isPersonalInformation: true, searchPhrase: [], helpPhrase: 'helpPhrase.companyId', isFiltered: false, essential: true },
                        employerName: { id: 'employerName', label: "form.job.employerName", datatype: 'string', criteriumLabel: 'Názov zamestnanca', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.employerName', isFiltered: false },
                        employerCIN: { id: 'employerCIN', label: "form.job.employerCIN", datatype: 'string', criteriumLabel: 'ID zamestnávateľa', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.employerCIN', isFiltered: false },
                        employerTIN: { id: 'employerTIN', label: "form.job.employerTIN", criteriumLabel: 'Daňové ID zamestnávateľa', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.employerTIN', isFiltered: false },
                        jobClassification: { id: 'jobClassification', label: "form.job.jobClasification", criteriumLabel: 'Pracovné zaradenie', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.jobClassification', isFiltered: false },
                        workplaceMunicipality: { id: 'workplaceMunicipality', label: "form.job.workplaceMunicipality", criteriumLabel: 'Mesto zamestnania', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.workplaceMunicipality', isFiltered: false },
                        workplaceStreet: { id: 'workplaceStreet', label: "form.job.workplaceStreet", criteriumLabel: 'Ulica zamestnania', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.workplaceStreet', isFiltered: false },
                        workplaceZipCode: { id: 'workplaceZipCode', label: "form.job.workplaceZipCode", criteriumLabel: 'PSČ zamestnania', datatype: 'string', multivalued: false, isPersonalInformation: true, searchPhrase: '', helpPhrase: 'helpPhrase.workplaceZipCode', isFiltered: false }
                    }
                }
            },
        }
    },
    methods: {
        tabLabelHash (label) {
            return label.toLowerCase().replace(/ /g, '-')
        },
        setMonthLabels () {
             return [this.$t("leftSideMenu.months.january"), this.$t("leftSideMenu.months.february"), this.$t("leftSideMenu.months.march"), this.$t("leftSideMenu.months.april"), this.$t("leftSideMenu.months.may"), this.$t("leftSideMenu.months.june"), this.$t("leftSideMenu.months.july"), this.$t("leftSideMenu.months.august"), this.$t("leftSideMenu.months.september"), this.$t("leftSideMenu.months.october"), this.$t("leftSideMenu.months.november"),this.$t("leftSideMenu.months.december")]
        },
        yearMonthFormmater (value) {
            var dates = value.substring(0, 7).split('-')
            return (dates[1][0] === '0' ? this.monthsLabels[parseInt(dates[1][1]) - 1] : this.monthsLabels[parseInt(dates[1]) - 1]) + ' ' + dates[0]
        },
        datetimeFormatter (value) {
            var date = new Date(value)
            return date.getDate() + '. ' + this.monthsLabels[date.getMonth()] + ' ' + date.getFullYear() + ' o ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
        },
        setMetadataObjects () {
            this.metadataObjects = []
            this.metadataObjects.push({
                label: "metadataObjectLabels.xlsDocument",
                id: 'COOMSOFFICE@1.1:ExcelObject',
                hash: this.tabLabelHash('XLS dokument'),
                aggregatedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                searchRecordMetadataFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                exportedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']]
            })
            this.metadataObjects.push({
                label: "metadataObjectLabels.wordDocument",
                id: 'COOMSOFFICE@1.1:WinWordObject',
                hash: this.tabLabelHash('Word dokument'),
                aggregatedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                searchRecordMetadataFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                exportedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']]
            })
            this.metadataObjects.push({
                label: "metadataObjectLabels.pdfDocument",
                id: 'FSCACROBAT@1.1:PDFObject',
                hash: this.tabLabelHash('PDF dokument'),
                aggregatedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                searchRecordMetadataFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                exportedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']]
            })
            this.metadataObjects.push({
                label: "metadataObjectLabels.txtDocument",
                id: 'TXTDocument',
                hash: this.tabLabelHash('Textový dokument'),
                aggregatedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                searchRecordMetadataFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                exportedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']]
            })
            this.metadataObjects.push({
                label: "metadataObjectLabels.all",
                id: this.allResultTagId,
                hash: this.allResultTagId,
                aggregatedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']],
                searchRecordMetadataFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate'], this.$root.metadataFields['lastModificationDate']],
                exportedFields: [this.$root.metadataFields['sourceId'], this.$root.metadataFields['lastModificationDate'], this.$root.metadataFields['createdBy'], this.$root.metadataFields['creationDate']]
            })
        },
        setMetadataFields () {
            return { 
                sourceId: { 
                    id: 'sourceId', 
                    label: "metadataFieldLabels.sourceLabel", 
                    datatype: 'string', 
                    searchPhrase: '', 
                    helpPhrase: this.$t("metadataFieldsHelpPhrases.sourceHelp"), 
                    dependOn: [] 
                },
                createdBy: { 
                    id: 'createdBy', 
                    label: "metadataFieldLabels.createdByLabel", 
                    datatype: 'string', 
                    searchPhrase: '', 
                    helpPhrase: this.$t("metadataFieldsHelpPhrases.createHelp"), 
                    dependOn: [], 
                    labelForSettlement: this.$t("metadataFieldsAlternativesPhrases.createdLabelForSettlement") 
                },
                creationDate: { 
                    id: 'creationDate', 
                    label: "metadataFieldLabels.creationDateLabel", 
                    datatype: 'datetime', 
                    aggregation: {
                        type: "date_histogram",
                        interval: "month",  // Adjustable: "day", "week", "month", "year"
                        format: "yyyy-MM-dd",
                        min_doc_count: 1
                    }, 
                    helpPhrase: "metadataFieldsHelpPhrases.creationHelp", 
                    dependOn: [] 
                },
                lastModificationDate: { 
                    id: 'lastModificationDate', 
                    label: "metadataFieldLabels.lastModificationDateLabel", 
                    datatype: 'datetime', 
                    aggregation: {
                        type: "date_histogram",
                        interval: "month",
                        format: "yyyy-MM-dd",
                        min_doc_count: 1
                    }, 
                    helpPhrase: "metadataFieldsHelpPhrases.lastModificationDateHelp", 
                    dependOn: []
                }
            }
        },
    },
    created: function () {
        this.monthsLabels = this.setMonthLabels()
        this.metadataFields = this.setMetadataFields()
        this.setMetadataObjects()
        this.metadataConfigManager = { metadataObjects: this.metadataObjects, metadataFields: this.metadataFields, metadataGDPRFields: this.metadataGDPRFields }
        store.commit('setGlobalConfig', {
            URL_BACKEND: this.URL_BACKEND,
            ENDPOINT_SEARCH: this.ENDPOINT_SEARCH,
            ENDPOINT_EXPORT: this.ENDPOINT_EXPORT,
            ENDPOINT_HIGHLIGHT: this.ENDPOINT_HIGHLIGHT
        });
        store.commit('setAggregations', { metadataObjects: this.metadataObjects, aggFieldForTab: this.aggFieldForTab });
        store.commit('setPageNumber', 1);
    },
    render: () => (h(App))
});

app.use(store).use(VueAxios, axios).use(router).use(i18n).use(SimpleTypeahead);
app.component("font-awesome-icon", FontAwesomeIcon);
export const mounted = app.mount('#app');
export {i18n};